import React from 'react';

const BudgetTracker = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
    width="100%"
    viewBox="0 0 97 98"
  >
    <defs>
      <linearGradient id="v6aawsgzpc" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#F8F8F8" />
        <stop offset="100%" stopColor="#F9F9F9" />
      </linearGradient>
      <linearGradient
        id="6briqjagjd"
        x1="31.569%"
        x2="68.431%"
        y1="63.17%"
        y2="32.527%"
      >
        <stop offset="0%" stopColor="#FF7F00" />
        <stop offset="100%" stopColor="#FFBE00" />
      </linearGradient>
      <linearGradient id="5525h2kvye" x1="112.877%" x2="0%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#FF9F68" />
        <stop offset="100%" stopColor="#F16159" />
      </linearGradient>
      <linearGradient
        id="29rzcsbccf"
        x1="34.003%"
        x2="59.031%"
        y1="79.971%"
        y2="10.464%"
      >
        <stop offset="0%" stopColor="#66EADC" />
        <stop offset="100%" stopColor="#40A499" />
      </linearGradient>
      <filter
        id="247tqbxs8a"
        width="106.5%"
        height="106.4%"
        x="-3.2%"
        y="-3.2%"
        filterUnits="objectBoundingBox"
      >
        <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="1"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
      </filter>
      <rect id="ywgeggr7bb" width="93" height="94" x="0" y="0" rx="23" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g transform="translate(-129 -328) translate(131 330)">
            <use
              fill="#000"
              filter="url(#247tqbxs8a)"
              xlinkHref="#ywgeggr7bb"
            />

            <use fill="url(#v6aawsgzpc)" xlinkHref="#ywgeggr7bb" />
          </g>
          <g transform="translate(-129 -328) translate(131 330) translate(17 27)">
            <rect
              width="17"
              height="28"
              x="21.5"
              y="12"
              fill="url(#6briqjagjd)"
              rx="3"
            />
            <circle cx="8.5" cy="32.5" r="8.5" fill="url(#5525h2kvye)" />
            <rect
              width="17"
              height="40"
              x="43"
              fill="url(#29rzcsbccf)"
              rx="3"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default BudgetTracker;
